
import React from 'react';

interface LoadingBarProps {
    isLoading: boolean;
    text?: string;
}

export const LoadingBar: React.FC<LoadingBarProps> = ({ isLoading, text }) => {
    if (!isLoading) return null;
    return (
        <div className="fixed top-0 left-0 right-0 z-[100]">
            <div className="h-1 w-full overflow-hidden bg-rose-100/30">
                <div className="h-full bg-gradient-to-r from-rose-500 via-white to-rose-500 animate-[shimmer_1.5s_infinite] w-[200%] -translate-x-full"></div>
            </div>
            {text && (
                <div className="absolute top-4 left-1/2 -translate-x-1/2 px-4 py-2 bg-white/90 backdrop-blur-sm rounded-full shadow-lg border border-rose-100 flex items-center gap-3">
                    <div className="w-2 h-2 bg-rose-500 rounded-full animate-pulse"></div>
                    <span className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] whitespace-nowrap">
                        {text}
                    </span>
                </div>
            )}
        </div>
    );
};
